import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import routes from "routes";
import { useMaterialUIController, setDarkMode } from "context";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    direction,
    sidenavColor,
    darkMode,
  } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode !== null) {
      setDarkMode(dispatch, JSON.parse(savedDarkMode));
    }
  }, [dispatch]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      return <Route exact path={route.route} element={route.component} key={route.key} />;
  });

  const themeValue = darkMode ? themeDark : theme;
  return (
    <ThemeProvider theme={themeValue}>
      <CssBaseline />
      <Sidenav theme={themeValue} color={sidenavColor} brandName="Menu" routes={routes} />
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/landing" />} />
      </Routes>
    </ThemeProvider>
  );
}
